import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Icon, Form, Message} from 'semantic-ui-react';
import {isNil} from 'ramda';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {updateUser} from '../../api';
import {loadUser, patchUser} from '../../util/Session';
import {GreenButton, DefaultButton, ButtonsGroup} from '../Button/ButtonMix';
import {FormInputLogin} from './FormInputMix';
import CodeOfConductPdf from '../../security/code-of-conduct.pdf';
import PrivacyPolicyPdf from '../../security/privacy-policy.pdf';

const EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
const MINIMUM_PASSWORD_LENGTH = 6;

const StyledForm = styled(Form)`
  background-color: transparent !important;
  border: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

const Footer = styled.div`
  margin: 30px 0 20px;
  & p {
    color: #222222;
  }
  & .checkbox {
    margin-bottom: 20px;
    & label {
      color: #222222;
      & a {
        color: #0A8DE2
        text-decoration: underline;
      }
    }
  }
`;


class UserProfileForm extends Component {
  constructor(props) {
    super(props);
    
    const user = loadUser();
    this.state = {
      errors: [],
      id: user ? user.id : null,
      firstName: user ? user.first_name : '',
      lastName: user ? user.last_name : '',
      email: user ? user.email : '',
      password: '',
      verifyPassword: '',
      isAgreedToPrivacyPolicy: false
    };
  }
  
  handleChange = (e, {name, value}) => this.setState({errors: [], [name]: value});
  
  handleCheckboxChange = (e, {name}) => this.setState({[name]: !this.state[name]});
  
  handleSubmit = () => {
    const {router, isUpdate, onCreate} = this.props;
    const {id, firstName, lastName, email, password, verifyPassword} = this.state;
    
    const errors = [];
    
    // validate email
    if (!EMAIL_REGEX.test(email)) {
      errors.push('Please enter a valid email address');
    }
    
    // validate passwords
    if (password.length < MINIMUM_PASSWORD_LENGTH) {
      errors.push(`Password must be at least ${MINIMUM_PASSWORD_LENGTH} characters long`);
    } else if (password !== verifyPassword) {
      errors.push('Passwords do not match');
    }
    
    // check for validation errors
    if (errors.length > 0) {
      this.setState({errors});
      return null;
    }
    
    const json = {
      user: {
        first_name: firstName,
        last_name: lastName,
        email: email,
        password: password,
        verify_password: verifyPassword
      }
    };
    
    const upsert = isUpdate ? () => updateUser(id, json) : () => onCreate(json);
    return upsert()
      .then(response => {
        const user = response.data;
        patchUser(user);
        router.push('/dashboard');
        return null;
      })
      .catch(e => {
        const apiErrors = e.response ? [e.response.data.error] : [e.message];
        this.setState({errors: apiErrors});
      });
  };
  
  render() {
    const {errors, firstName, isAgreedToPrivacyPolicy, lastName, email, password, verifyPassword} = this.state;
    const {isUpdate, router, onCancel} = this.props;
    const isError = !isNil(errors) && errors.length > 0;
    
    const submitButtonText = isUpdate ? 'Update' : 'Sign-up';
    const checkboxlabel = <label>I acknowledge I have read and agree to the Terms of Use, <a href={CodeOfConductPdf} rel="noopener noreferrer" target="_blank"> Code of Conduct</a>, and <a href={PrivacyPolicyPdf} rel="noopener noreferrer" target="_blank"> Privacy Policy</a>.</label>;
    // if user is just updating profile, we don't show checkboxes.  so button should always be enabled when updating user profile, as they can fill
    // out as many, or as few, fields as they want.  if this is during signup, then only show button if both checkboxes are checked
    const isSubmitButtonEnabled = isUpdate || isAgreedToPrivacyPolicy;
    
    return (
      <StyledForm error={isError} className="attached fluid segment" onSubmit={this.handleSubmit}>
        <Message error icon>
          <Icon name="exclamation triangle"/>
          <Message.Content>
            <Message.Header>Error</Message.Header>
            {[errors].filter(e => !isNil(e)).join(', ')}
          </Message.Content>
        </Message>
        <FormInputLogin fluid value={firstName} label="First Name" type="text" name="firstName" placeholder="First Name" onChange={this.handleChange} required/>
        <FormInputLogin fluid value={lastName} label="Last Name" type="text" name="lastName" placeholder="Last Name" onChange={this.handleChange} required/>
        <FormInputLogin value={email} label="Email" name="email" type="text" placeholder="Email" onChange={this.handleChange} required/>
        <FormInputLogin value={password} label="Password" type="password" name="password" placeholder="Password" onChange={this.handleChange} required/>
        <FormInputLogin value={verifyPassword} label="Verify Password" type="password" name="verifyPassword" placeholder="Verify Password" onChange={this.handleChange} required/>
        {
          !isUpdate && (
            <Footer>
              <Checkbox
                id="privacyPolicyCheckbox" 
                name="isAgreedToPrivacyPolicy" 
                onChange={this.handleCheckboxChange} 
                required
                label={checkboxlabel}
              />
              <p>
                Your name & points may be shared with team members and certain school officials specific to your account for the reward programs related to BodyBank.
              </p>
            </Footer>
          )
        }
        <ButtonsGroup>
          <DefaultButton onClick={isNil(onCancel) ? router.goBack : onCancel}>Cancel</DefaultButton>
          <GreenButton disabled={!isSubmitButtonEnabled}>{submitButtonText}</GreenButton>
        </ButtonsGroup>
      </StyledForm>
    );
  }
}

UserProfileForm.propTypes = {
  router: PropTypes.object.isRequired,
  isUpdate: PropTypes.bool,
  onCancel: PropTypes.func,
  // Not required if this is an update
  onCreate: PropTypes.func
};

export default withRouter(UserProfileForm);



// WEBPACK FOOTER //
// ./src/components/Form/UserProfileForm.js